import { Environment } from "shared";
import { getEnvironment } from "@web/utils/env/getEnvironment";

export function isProd(): boolean {
  return getEnvironment() === Environment.Production;
}
